import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    getAlignmentUrl,
    geteEditSpecificStyleUrl,
    getStylesDetailsUrl,
} from 'src/app/constants/private/urls/projects/edit-style.urls';
import { getSaveEditUrlPUT, getUpdateEditPropertyPutUrl } from 'src/app/constants/private/urls/projects/edit.urls';
import { ISubtitleStyle, SUBTITLE_STRATEGY } from 'sfl-subtitles-helper/dist/subtitles-helper';
const STRATEGY_URL = '/strategy';
const UPDATE_EDIT_SUBTITLE_PROPERTY_URL = '/property';

@Injectable({
    providedIn: 'root',
})
export class EditStyleApiService {
    constructor(private http: HttpClient) {}

    updateSubtitleStyleProperty$(params: {
        projectId: string;
        editId: string;
        settingId: string;
        key: string;
        value: any;
    }) {
        const putPropertyToEditUrl = geteEditSpecificStyleUrl(params.projectId, params.editId, params.settingId);
        return this.http.put<ISubtitleStyle>(putPropertyToEditUrl, params);
    }

    updateSubtitleAlignment$(projectId: string, editId: string, marginV: string) {
        const putPropertyToEditUrl = getAlignmentUrl(projectId, editId);
        return this.http.put<ISubtitleStyle>(putPropertyToEditUrl, {
            projectId,
            editId,
            marginV,
        });
    }
    updateEditProperty$(params: {
        projectId: string;
        editId: string;
        key: 'strategy' | 'toActive';
        value: SUBTITLE_STRATEGY | boolean;
    }) {
        const url = getUpdateEditPropertyPutUrl(params.projectId, params.editId);
        return this.http.put<SUBTITLE_STRATEGY>(`${url}${UPDATE_EDIT_SUBTITLE_PROPERTY_URL}`, params);
    }
}
